import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { FadeUp } from "@/components/Reveal";

const BlogCard = ({ post, index = 0, showImage = false, filled = false }) => (
  <FadeUp delay={index * 0.12} className="h-full">
    <Link
      to={`/blogs/${post.slug}`}
      data-testid={`blog-card-${post.slug}`}
      className="group flex flex-col h-full bg-white rounded-2xl p-5 transition-all duration-500 hover:-translate-y-1.5 hover:shadow-[0_24px_48px_rgba(17,17,17,0.12)]"
      style={{ boxShadow: "0 12px 30px rgba(17,17,17,0.06)" }}
    >
      <div className="flex items-center justify-between">
        <span className="w-2.5 h-2.5 rounded-full" style={{ background: post.dot }} />
        <span className="text-sm font-medium text-[#111]/50">{post.readTime}</span>
      </div>

      {showImage && (
        <div className="mt-4 rounded-xl overflow-hidden aspect-[16/9]">
          <img
            src={post.image}
            alt={post.title}
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
        </div>
      )}

      <h3 className="mt-4 text-xl sm:text-[22px] font-semibold leading-snug tracking-tight group-hover:text-[#8C5EBA] transition-colors duration-300">
        {post.title}
      </h3>
      <p className="mt-3 text-sm leading-relaxed text-[#111]/55 line-clamp-3">{post.excerpt}</p>

      <div className="mt-auto pt-5 flex justify-end">
        <span
          className={`w-12 h-9 rounded-full flex items-center justify-center transition-all duration-300 ${
            filled
              ? "bg-[#8C5EBA] text-white group-hover:bg-[#111]"
              : "border border-[#8C5EBA] text-[#8C5EBA] group-hover:bg-[#8C5EBA] group-hover:text-white"
          }`}
        >
          <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-0.5" />
        </span>
      </div>
    </Link>
  </FadeUp>
);

export default BlogCard;
